import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/src/app/scss/main.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/layout.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/src/app/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-monument-grotesk\",\"src\":[{\"path\":\"./MonumentGrotesk-Bold.woff\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"./MonumentGrotesk-Medium.woff\",\"weight\":\"500\",\"style\":\"normal\"},{\"path\":\"./MonumentGrotesk-Regular.woff\",\"weight\":\"400\",\"style\":\"normal\"}]}],\"variableName\":\"MonumentGrotesk\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/entities/analytics/ui/InitAnalytics/InitAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/shared/ui/NoSSSR/NoSSSR.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Footer/ui/Footer/Footer.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/shared/ui/Container/Container.scss");
;
import(/* webpackMode: "eager" */ "/app/src/src/widgets/Header/ui/Header/Header.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/src/widgets/Header/ui/LangsToggler/LangsToggler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutChrome"] */ "/app/src/src/widgets/LayoutChrome/ui/LayoutChrome.tsx");
